import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import useExcelUrl from "app/useExcelUrl";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import { DictionaryItem } from "features/dictionaries/dictionaryApi";
import useDictionaries from "features/dictionaries/useDictionaries";
import { UserItem } from "features/users/userApi";
import I18n from "i18n";
import { NotificationAddressItem } from "./notificationAddressApi";
import NotificationAddressForm from "./NotificationAddressForm";
import useNotificationAddressList from "./useNotificationAddressList";

export interface NotificationAddressListProps
  extends Omit<DataGridBaseBaseProps, "id"> {
  showHeader?: boolean;
}

export default function NotificationAddressList({
  showHeader = true,
  ...props
}: NotificationAddressListProps) {
  const { params, scope, editUrl, ...service } = useNotificationAddressList();
  const { resolveOption } = useDictionaries();
  const excelUrl = useExcelUrl("notificationAddresss");

  let columns: GridColumns<NotificationAddressItem> = [
    {
      field: "key",
      headerName: I18n.t("NotificationAddress.attributes.key"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={{
            ...params,
            value: I18n.t(`NotificationAddress.options.key.${params.value}`),
          }}
        />
      ),
      flex: 1,
    },
    {
      field: "user_ids",
      headerName: I18n.t("NotificationAddress.attributes.user_ids"),
      flex: 1,
      renderCell: params =>
        (
          params.row.user_ids?.map(
            user_id =>
              resolveOption<DictionaryItem<UserItem>>("users", user_id)?.label
          ) || []
        ).join(", "),
    },
    {
      field: "external_emails",
      headerName: I18n.t("NotificationAddress.attributes.external_emails"),
      flex: 1,
      renderCell: params => (params.row.external_emails || []).join(", "),
    },
    {
      field: "send_email",
      headerName: I18n.t("NotificationAddress.attributes.send_email"),
      type: "boolean",
    },
    {
      field: "send_push",
      headerName: I18n.t("NotificationAddress.attributes.send_push"),
      type: "boolean",
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<EditNotificationsIcon />}
          title={I18n.t("NotificationAddress.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="notificationAddresss"
        excelUrl={excelUrl}
        renderModalForm={props => (
          <NotificationAddressForm
            {...props}
            defaultValues={{ send_email: true, send_push: false }}
          />
        )}
        {...props}
        canCreate={true}
        canDelete={true}
        canEdit={true}
        canDeleteRow={() => true}
        canEditRow={() => true}
        canBatchActions={true}
        canHandleTrash={true}
      />
    </>
  );
}
